import {proxy} from './proxy';

export const proxifiedFetch = (input: RequestInfo, init?: RequestInit): Promise<Response> =>
  typeof input === 'string' ? fetch(proxy(input), init) : fetch(new Request(proxy(input.url), input), init);
